var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"img-container"},_vm._l((_vm.charecters),function(char,index){return _c('img',{key:index,staticClass:"mint-image",attrs:{"src":("/charecters/" + char),"alt":char}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }